import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

// ---------------------------------------------------------------------------
// Layout constants — shared across card, grid, pill, and skeleton
// ---------------------------------------------------------------------------

export const LOCATION_PILL_MAX_WIDTH = 96; // 3 chips fit per row at max-width
export const LOCATION_SECTION_HEIGHT = 52; // 2 rows × 24px + 4px gap
export const USER_SECTION_HEIGHT = 32;
export const CARD_WIDTH = 344;
export const CARD_HEIGHT = 215;
export const BREAKPOINT_SMALL_MAX = 570;

// ---------------------------------------------------------------------------
// Shared CSS declarations
// ---------------------------------------------------------------------------

export const gridStyles = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${CARD_WIDTH}px, ${CARD_WIDTH}px));
  gap: ${theme.spacing(1.5)};
  align-content: start;
  justify-content: center;
`;

export const gridViewportStyles = css`
  box-sizing: border-box;
  height: calc(${CARD_HEIGHT * 2}px + ${theme.spacing(3)});
  padding-bottom: ${theme.spacing(1.5)};
  overflow-y: auto;
`;

export const topSectionStyles = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.spacing(0.125)};
`;

export const cardStyles = css`
  box-sizing: border-box;
  width: ${CARD_WIDTH}px;
  height: ${CARD_HEIGHT}px;
  background: ${theme.colors.white};
  border: 2px solid ${theme.colors.neutral20};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacing(2)};
  min-width: 0;
`;

export const interactiveCardStyles = css`
  ${cardStyles};
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border: 2px solid ${theme.colors.primary30};
    box-shadow: 0 1px 4px ${theme.colors.neutral20};
  }
`;
